// Meal data for Nova Foods Fitness Subscription

export const PRICING = {
  'weight-loss': { weekly: 1350, monthly: 4800 },
  'muscle-gain': { weekly: 1350, monthly: 4800 },
  'lunch': { weekly: 1450, monthly: 5500 },
  'dinner': { weekly: 1450, monthly: 5500 },
};

export const PLANS = {
  'weight-loss': {
    title: 'Weight Loss Plan',
    subtitle: 'High protein, calorie-controlled post-workout meals designed to support fat loss while preserving muscle.',
    color: '#1A4331',
    bgColor: '#1A4331',
    meals: [
      {
        day: 'Monday',
        name: 'Hung Curd Sandwich',
        calories: 300,
        protein: 18,
        fibre: 5,
        image: '/meals/hung-curd-sandwich.png',
      },
      {
        day: 'Tuesday',
        name: 'Protein Salad',
        calories: 320,
        protein: 25,
        fibre: 6,
        image: '/meals/paneer-protein-salad.png',
        options: ['Paneer Protein Salad', 'Chicken Protein Salad'],
      },
      {
        day: 'Wednesday',
        name: 'Protein Fruit Yogurt Bowl',
        calories: 300,
        protein: 20,
        fibre: 5,
        image: '/meals/protein-fruit-yogurt.png',
      },
      {
        day: 'Thursday',
        name: 'Sprouts Bhel Protein Bowl',
        calories: 280,
        protein: 18,
        fibre: 8,
        image: '/meals/sprouts-bhel-protein.png',
      },
      {
        day: 'Friday',
        name: 'Protein Wrap',
        calories: 350,
        protein: 28,
        fibre: 6,
        image: '/meals/protein-wrap.png',
        options: ['Paneer Wrap', 'Chicken Wrap'],
      },
    ],
  },
  'muscle-gain': {
    title: 'Muscle Gain Plan',
    subtitle: 'High protein, higher calorie post-workout meals designed to support muscle growth and recovery.',
    color: '#C05C3D',
    bgColor: '#C05C3D',
    meals: [
      {
        day: 'Monday',
        name: 'Paneer Power Sandwich',
        calories: 550,
        protein: 30,
        fibre: 6,
        image: '/meals/paneer-power-sandwich.png',
      },
      {
        day: 'Tuesday',
        name: 'Power Bowl',
        calories: 600,
        protein: 35,
        fibre: 8,
        image: '/meals/paneer-power-bowl.png',
        options: ['Paneer Power Bowl', 'Chicken Power Bowl'],
      },
      {
        day: 'Wednesday',
        name: 'Fruit mix Protein Yogurt Bowl',
        calories: 500,
        protein: 25,
        fibre: 6,
        image: '/meals/mango-protein-yogurt.png',
      },
      {
        day: 'Thursday',
        name: 'Paneer & Sweet Potato Recovery Bowl',
        calories: 600,
        protein: 35,
        fibre: 9,
        image: '/meals/paneer-sweet-potato.png',
      },
      {
        day: 'Friday',
        name: 'Power Wrap',
        calories: 550,
        protein: 35,
        fibre: 6,
        image: '/meals/power-wrap.png',
        options: ['Paneer Power Wrap', 'Heavy Chicken Wrap'],
      },
    ],
  },
};

export const LUNCH_PLAN = {
  title: 'Lunch Subscription',
  subtitle: 'Balanced, protein-rich meals for your everyday fitness routine.',
  color: '#0F766E',
  meals: [
    {
      day: 'Monday',
      name: 'Paneer Protein Chilla',
      description: '3 pieces · Curd',
      image: 'https://images.unsplash.com/photo-1614128867650-4d971a244a0a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
    {
      day: 'Tuesday',
      name: 'Plain Biryani',
      description: 'Choose Chicken or Paneer',
      image: 'https://images.unsplash.com/photo-1697155406055-2db32d47ca07?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
      options: ['Ghee Chicken Biryani', 'Ghee Paneer Biryani'],
    },
    {
      day: 'Wednesday',
      name: 'Grilled Power Bowl',
      description: 'Choose Chicken or Paneer',
      image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
      options: ['Grilled Chicken Power Bowl', 'Grilled Paneer Power Bowl'],
    },
    {
      day: 'Thursday',
      name: 'Bhurji & Multigrain Roti',
      description: '3 multigrain rotis · Curd',
      image: 'https://images.unsplash.com/photo-1756821753016-c2fa118465a6?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
      options: ['Paneer Bhurji & Roti', 'Egg Bhurji & Roti'],
    },
    {
      day: 'Friday',
      name: 'High-Protein Paneer Dal Khichdi',
      description: 'Buttermilk',
      image: 'https://images.unsplash.com/photo-1727018953313-403d17215a1b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
  ],
};

export const DINNER_PLAN = {
  title: 'Dinner Subscription',
  subtitle: 'Light, nutritious and protein-focused dinners for a healthy lifestyle.',
  color: '#4338CA',
  meals: [
    {
      day: 'Monday',
      name: 'Grilled & Veggies',
      description: 'Choose Chicken or Paneer',
      image: 'https://images.pexels.com/photos/1247677/pexels-photo-1247677.jpeg?auto=compress&cs=tinysrgb&h=650&w=940',
      options: ['Grilled Chicken & Veggies', 'Grilled Paneer & Veggies'],
    },
    {
      day: 'Tuesday',
      name: 'Egg & Paneer Protein Plate',
      image: 'https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
    {
      day: 'Wednesday',
      name: 'Soya Chunk & Sweet Potato Power Bowl',
      image: 'https://images.unsplash.com/photo-1619957666462-23c135cb215b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
    {
      day: 'Thursday',
      name: 'Avocado Toast & Eggs',
      image: 'https://images.unsplash.com/photo-1613769049987-b31b641f25b1?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
    },
    {
      day: 'Friday',
      name: 'Tikka Salad Bowl',
      description: 'Choose Chicken or Paneer',
      image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600',
      options: ['Chicken Tikka Salad Bowl', 'Paneer Tikka Salad Bowl'],
    },
  ],
};
